import { render } from "./FormConsultaComponent.vue?vue&type=template&id=7d036cd6"
import script from "./FormConsultaComponent.vue?vue&type=script&lang=js"
export * from "./FormConsultaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__